import { Pagination as BSPagination } from "react-bootstrap";
import "./index.scss";

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  showFirstLast = true,
  showPrevNext = true,
  maxVisiblePages = 5,
  size = "md",
  all = false,
}) => {
  // Se não há páginas suficientes para mostrar paginação, não renderiza
  if (totalPages <= 1 || all) {
    return null;
  }

  const handlePageClick = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Calcular quais páginas mostrar
  const getVisiblePages = () => {
    const pages = [];
    const halfVisible = Math.floor(maxVisiblePages / 2);

    let startPage = Math.max(1, currentPage - halfVisible);
    let endPage = Math.min(totalPages, currentPage + halfVisible);

    // Ajustar se não temos páginas suficientes de um lado
    if (endPage - startPage + 1 < maxVisiblePages) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="d-flex flex-column justify-content-start align-items-start my-4 pdl_component_pagination">
      <div className="separator"></div>
      <BSPagination size={size} className="mb-0 ms-4">
        {/* Primeira página */}
        {showFirstLast && currentPage > 1 && (
          <BSPagination.First
            onClick={() => handlePageClick(1)}
            title="Primeira página"
          />
        )}

        {/* Página anterior */}
        {showPrevNext && currentPage > 1 && (
          <BSPagination.Prev
            onClick={() => handlePageClick(currentPage - 1)}
            title="Página anterior"
          />
        )}

        {/* Reticências no início */}
        {visiblePages[0] > 1 && (
          <>
            <BSPagination.Item onClick={() => handlePageClick(1)}>
              1
            </BSPagination.Item>
            {visiblePages[0] > 2 && <BSPagination.Ellipsis disabled />}
          </>
        )}

        {/* Páginas visíveis */}
        {visiblePages.map((page) => (
          <BSPagination.Item
            key={page}
            active={page === currentPage}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </BSPagination.Item>
        ))}

        {/* Reticências no final */}
        {visiblePages[visiblePages.length - 1] < totalPages && (
          <>
            {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
              <BSPagination.Ellipsis disabled />
            )}
            <BSPagination.Item onClick={() => handlePageClick(totalPages)}>
              {totalPages}
            </BSPagination.Item>
          </>
        )}

        {/* Próxima página */}
        {showPrevNext && currentPage < totalPages && (
          <BSPagination.Next
            onClick={() => handlePageClick(currentPage + 1)}
            title="Próxima página"
          />
        )}

        {/* Última página */}
        {showFirstLast && currentPage < totalPages && (
          <BSPagination.Last
            onClick={() => handlePageClick(totalPages)}
            title="Última página"
          />
        )}
      </BSPagination>
    </div>
  );
};

export default Pagination;
